import {NgModule} from '@angular/core';
import {TranslateModule} from '@ngx-translate/core';
import {MDBBootstrapModulesPro} from 'ng-uikit-pro-standard';
import {CommonModule} from '@angular/common';
import {BuildingsNavbarComponent} from './navbar/buildings-navbar.component';
import {BuildingTileComponent} from './building-tile/building-tile.component';
import {MeterListItemComponent} from './meter-list-item/meter-list-item.component';
import {BuildingListItemComponent} from './building-list-item/building-list-item.component';
import {BuildingListHeaderComponent} from './building-list-header/building-list-header.component';
import {CreateBuildingModalComponent} from './create-building-modal/create-building-modal.component';
import {ReactiveFormsModule} from '@angular/forms';
import {ChappsCommonAngularLibraryModule} from '@npm.chapps.com/chapps.common.angular.library';
import {CommonsModule} from '../../common/common.module';
import {UpdateMeterDetailsModalComponent} from './update-meter-details-modal/update-meter-details-modal.component';
import {CreateBuildingContactModalComponent} from './create-building-contact-modal/create-building-contact-modal.component';
import {CreateBuildingStructureContactModalComponent} from './create-building-structure-contact-modal/create-building-structure-contact-modal.component';
import {EditBuildingModalComponent} from './edit-building-modal/edit-building-modal.component';
import {AddOrUpdateMeterModalComponent} from '../structure/details/pages/meters/add-or-update-meter-modal/add-or-update-meter-modal.component';
import { BuildingReportSelectionDialog } from './app-building-report-selection/building-report-selection-dialog.component';
import { BuildingSelectionComponent } from './building-selection/building-selection.component';
import { InspectionTableFiltersComponent } from './building-inspections-table/inspection-table-filters/inspection-table-filters.component';
import {ChecklistsModule} from '../checklists/checklists.module';

@NgModule({
    imports: [
        CommonModule,
        CommonsModule,
        TranslateModule.forChild(),
        ReactiveFormsModule,
        MDBBootstrapModulesPro,
        ChappsCommonAngularLibraryModule,
        ChecklistsModule,
    ],
    declarations: [
        BuildingsNavbarComponent,
        BuildingTileComponent,
        MeterListItemComponent,
        BuildingListItemComponent,
        BuildingListHeaderComponent,
        CreateBuildingModalComponent,
        EditBuildingModalComponent,
        UpdateMeterDetailsModalComponent,
        CreateBuildingContactModalComponent,
        CreateBuildingStructureContactModalComponent,
        AddOrUpdateMeterModalComponent,
        BuildingReportSelectionDialog,
        BuildingSelectionComponent,
        InspectionTableFiltersComponent,
    ],
    exports: [
        BuildingsNavbarComponent,
        BuildingTileComponent,
        MeterListItemComponent,
        BuildingListItemComponent,
        BuildingListHeaderComponent,
        CreateBuildingModalComponent,
        EditBuildingModalComponent,
        UpdateMeterDetailsModalComponent,
        CreateBuildingContactModalComponent,
        CreateBuildingStructureContactModalComponent,
        AddOrUpdateMeterModalComponent,
        BuildingSelectionComponent,
    ]
})
export class BuildingComponentsModule {}
